import { api } from "@/lib/api";

// The signed-in user's own record (ADR-0007 slice F).
export namespace MeApi {
  /**
   * The caller's own user record, or undefined when the token authenticates
   * something that is not a portal user (a superuser token, say).
   *
   * Throws on a failed request, and the status matters: authz.RequireAuth
   * answers a token it cannot resolve with a real 401. The collection read
   * this replaces could not do that — PocketBase's auth middleware serves an
   * unusable token as a GUEST, and a guest failing a collection rule gets
   * "The requested resource wasn't found.", so an over session and a missing
   * record were the same 404. See auth-session.ts.
   */
  export async function fetchMe<TUser>(signal?: AbortSignal): Promise<TUser | undefined> {
    const res = await api<{ user: TUser | null }>("/app/me", { method: "GET", signal });
    return res.user ?? undefined;
  }
}
